import { render } from "./SalesControl.vue?vue&type=template&id=15b3c8b2&scoped=true"
import script from "./SalesControl.vue?vue&type=script&lang=js"
export * from "./SalesControl.vue?vue&type=script&lang=js"

import "./SalesControl.vue?vue&type=style&index=0&id=15b3c8b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b3c8b2"]])

export default __exports__